import React from "react";
import "./App.css";

function Contact() {
  return (
    <div className="page-container content-page">
      <div className="container">
        <h1 className="page-title">How To Reach Us</h1>

        <div className="contact-grid">
          <div className="address-box">
            <h3>Visit Us</h3>
            <p className="address-text">
              A11, Sector P3
              <br />
              Greater Noida, GB Nagar
              <br />
              Uttar Pradesh, 201310
            </p>

            <div className="phone-contacts">
              <h3>Book Appointment Now</h3>
              {/* Clickable Phone Button */}
              <a href="tel:9310437126" className="call-now-btn">
                📞 Call +91 9310437126
              </a>
            </div>

            <button
              className="google-cal-btn"
              onClick={() =>
                window.open("https://calendar.google.com", "_blank")
              }
            >
              📅 Book via Google Calendar
            </button>
          </div>

          <div className="map-box">
            <iframe
              title="Doctor Location"
              width="100%"
              height="450"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://maps.google.com/maps?q=A11%20Sector%20P3%20Greater%20Noida&t=&z=13&ie=UTF8&iwloc=&output=embed"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
